import { RadioButton } from '@genially/design-system';

import {
  Description,
  Illustration,
  Title,
  TitleRow,
  Wrapper,
} from './ResultsModeCard.styled';

interface ResultsModeCardProps {
  description: string;
  groupName: string;
  illustrationSrc: string;
  isSelected: boolean;
  onSelect: () => void;
  title: string;
  value: string;
}

export const ResultsModeCard = ({
  description,
  groupName,
  illustrationSrc,
  isSelected,
  onSelect,
  title,
  value,
}: ResultsModeCardProps) => {
  const handleChange = () => onSelect();

  return (
    // The card is the radio's label, so clicking anywhere on it checks the input and
    // keyboard navigation between the three modes comes from the native radio group.
    <Wrapper $isSelected={isSelected}>
      <Illustration src={illustrationSrc} alt="" />
      <TitleRow>
        <RadioButton
          checked={isSelected}
          name={groupName}
          value={value}
          onChange={handleChange}
        />
        <Title>{title}</Title>
      </TitleRow>
      <Description>{description}</Description>
    </Wrapper>
  );
};
